import { isEmpty } from "lodash";
// import { logout } from "containers/App/actions";
// import { GLOBAL_LOGIN } from "containers/GlobalLogin/constants";
const TOKEN_KEY = "isAuthenticated";
const USER_INFO = "userInfo";

const parse = JSON.parse;
const stringify = JSON.stringify;
const SALT = "asasJHGJHFG^%$^&76576";

const auth = {
  /**
   * Encrypt Data to be save in localstorage
   * @param  {Object} o [description]
   * @param  {String} salt [description]
   */
  encript(o, salt) {
    o = JSON.stringify(o).split("");
    for (var i = 0, l = o.length; i < l; i++)
      if (o[i] === "{") o[i] = "}";
      else if (o[i] === "}") o[i] = "{";
    return encodeURI(salt + o.join(""));
  },
  /**
   * Decrypt Data to be save in localstorage
   * @param  {Object} o [description]
   * @param  {String} salt [description]
   */
  decript(o, salt) {
    o = decodeURI(o);
    if (salt && o.indexOf(salt) !== 0) return null;
    // throw new Error("object cannot be decripted");
    o = o.substring(salt.length).split("");
    for (var i = 0, l = o.length; i < l; i++)
      if (o[i] === "{") o[i] = "}";
      else if (o[i] === "}") o[i] = "{";
    return JSON.parse(o.join(""));
  },
  /**
   * Remove an item from the used storage
   * @param  {String} key [description]
   */
  clear(key) {
    if (localStorage && localStorage.getItem(key)) {
      return localStorage.removeItem(key);
    }
    if (sessionStorage && sessionStorage.getItem(key)) {
      return sessionStorage.removeItem(key);
    }

    return null;
  },

  /**
   * Clear all app storage
   */
  // clearAppStorage() {
  //   if (
  //     typeof IN === "object" &&
  //     typeof IN.User === "object" &&
  //     IN.User.isAuthorized()
  //   ) {
  //     //user logged in linkedin
  //     //call linkedin logout with websites logout function as callback
  //     IN.User.logout(logout);
  //   }

  //   if (localStorage) {
  //     localStorage.clear();
  //   }

  //   if (sessionStorage) {
  //     sessionStorage.clear();
  //   }
  // },

  clearToken(tokenKey = TOKEN_KEY) {
    return auth.clear(tokenKey);
  },

  clearUserInfo(userInfo = USER_INFO) {
    return auth.clear(userInfo);
  },

  /**
   * Returns data from storage
   * @param  {String} key Item to get from the storage
   * @return {String|Object}     Data from the storage
   */
  get(key) {
    if (localStorage && localStorage.getItem(key)) {
      return parse(localStorage.getItem(key)) || null;
    }

    if (sessionStorage && sessionStorage.getItem(key)) {
      return parse(sessionStorage.getItem(key)) || null;
    }

    return null;
  },

  getToken(tokenKey = TOKEN_KEY) {
    return auth.get(tokenKey);
  },

  getUserInfo(userInfo = USER_INFO) {
    const deUserInfo = auth.decript(auth.get(userInfo), SALT);
    return deUserInfo;
  },

  /**
   * Set data in storage
   * @param {String|Object}  value    The data to store
   * @param {String}  key
   * @param {Boolean} isLocalStorage  Defines if we need to store in localStorage or sessionStorage
   */
  set(value, key, isLocalStorage, remember) {
    if (isEmpty(value)) {
      return null;
    }

    if (remember) {
      if (isLocalStorage && localStorage) {
        return localStorage.setItem(key, stringify(value));
      }
    } else {
      if (sessionStorage) {
        return sessionStorage.setItem(key, stringify(value));
      }
    }

    return null;
  },

  setToken(
    value = "",
    isLocalStorage = false,
    remember = false,
    tokenKey = TOKEN_KEY
  ) {
    return auth.set(value, tokenKey, isLocalStorage, remember);
  },

  setUserInfo(
    value = "",
    isLocalStorage = false,
    remember = false,
    userInfo = USER_INFO
  ) {
    let enValue = auth.encript(value, SALT);
    return auth.set(enValue, userInfo, isLocalStorage, remember);
  }
};

const isAuthenticated = () => {
  if (auth.getToken() === null) return false;
  return true;
};

export { isAuthenticated, auth };



// WEBPACK FOOTER //
// ./src/shared/auth.js